import useAlert from '@/components/Alert/hooks/useAlert'
import { getBatchCsv, GetBatchCsvParams } from '../repository/getBatchCsv'
import { renderCsv } from '@/utils/renderCsv'
import submitBatchMetricsUpdate from '../repository/submitBatchMetricsUpdate'
import { useContext } from 'react'
import { OrdersContext } from '../storage/OrdersProvider'
import getBatchSnapshot, {
  BatchSnapshotParams
} from '../repository/getBatchSnapshot'

const CONTEXT_ERROR = 'usePhysicalOrders must be used within a OrdersProvider'
const BATCH_UPDATE_INFO = 'Batch Metrics Update is in progress.'

const usePhysicalOrders = () => {
  const context = useContext(OrdersContext)

  if (!context) throw new Error(CONTEXT_ERROR)

  const { setPreviewBatch, previewBatch } = context
  const { alertError, alertInfo } = useAlert()

  const downloadOpenOrders = async () => {
    const result = await getBatchCsv({ filters: { pending: true } })

    if ('error' in result) {
      alertError(result.error)
    } else {
      renderCsv(result.data, result.filename)
    }
  }

  const downloadBatchCsv = async (params: GetBatchCsvParams) => {
    const result = await getBatchCsv(params)

    if ('error' in result) {
      alertError(result.error)
    } else {
      renderCsv(result.data, result.filename)
    }
  }

  const updateBatchMetrics = async () => {
    const result = await submitBatchMetricsUpdate()

    if (result?.error) {
      alertError(result.error)
    } else {
      alertInfo(BATCH_UPDATE_INFO)
    }
  }

  const openBatchSnapshot = async (params: BatchSnapshotParams) => {
    const result = await getBatchSnapshot(params)

    if (result?.error) {
      alertError(result.error)
    } else {
      setPreviewBatch(result.data)
    }
  }

  return {
    previewBatch,
    setPreviewBatch,
    downloadOpenOrders,
    downloadBatchCsv,
    updateBatchMetrics,
    openBatchSnapshot
  }
}

export default usePhysicalOrders
